import Step from "./Step";

class Step9 extends Step {
    constructor() {
        super(10, 'location', $(`[data-register-step="location"]`));
        this.form = null;
        this.validator = null;
        this.submitButton = null;
        this.backButton = null;
    }

    init() {
        console.log('Step9 init: Factuurgegevens');
        // Get form elements
        this.form = document.querySelector('#location_info_form');
        this.submitButton = document.querySelector('#location_info_button');
        this.backButton = this.element.find('#back_to_fork_button');

        if (!this.form) return;

        // Initialize validation
        this.initValidation();

        // Bind form submit event
        this.handleSubmit();

        // Handle country change for VAT number visibility
        this.handleCountryChange();

        // Handle back button
        if (this.backButton) {
            this.backButton.on('click', (e) => {
                e.preventDefault();
                this.goToStep('congrats');
            });
        }

        // Pre-fill form if data exists
        this.populateForm();
    }

    initValidation() {
        // Define validation rules
        this.validator = FormValidation.formValidation(this.form, {
            fields: {
                ia_street: {
                    validators: {
                        notEmpty: {
                            message: 'Straat is verplicht'
                        }
                    }
                },
                ia_nr: {
                    validators: {
                        notEmpty: {
                            message: 'Huisnummer is verplicht'
                        }
                    }
                },
                ia_postal: {
                    validators: {
                        notEmpty: {
                            message: 'Postcode is verplicht'
                        }
                    }
                },
                ia_city: {
                    validators: {
                        notEmpty: {
                            message: 'Stad is verplicht'
                        }
                    }
                },
                ia_country: {
                    validators: {
                        notEmpty: {
                            message: 'Land is verplicht'
                        }
                    }
                },
                ia_vat_number: {
                    validators: {
                        callback: {
                            message: 'BTW nummer is verplicht voor buitenlandse bedrijven',
                            callback: (input) => {
                                const country = this.form.querySelector('[name="ia_country"]').value;
                                if (country !== 'nl' && !input.value) {
                                    return false;
                                }
                                return true;
                            }
                        }
                    }
                }
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidationBootstrap5({
                    rowSelector: '.fv-row'
                })
            }
        });
    }

    handleCountryChange() {
        const countrySelect = $(this.form.querySelector('[name="ia_country"]'));
        const vatLabel = $('#vat_number_container label');
        const vatInput = this.form.querySelector('[name="ia_vat_number"]');

        const updateVatRequirement = (val) => {
            if (val === 'nl') {
                // Remove 'required' class for NL
                vatLabel.removeClass('required');
                vatInput.placeholder = 'NL859606240B01';

                // If switching to optional (NL) and field is empty, reset validation to remove ticks/errors
                if (this.validator && !vatInput.value) {
                    this.validator.resetField('ia_vat_number', true);
                }
            } else {
                // Add 'required' class for other countries
                vatLabel.addClass('required');
                vatInput.placeholder = 'BE0123456789';
            }

            // Revalidate VAT field when country changes if it has a value
            if (this.validator && vatInput.value) {
                this.validator.revalidateField('ia_vat_number');
            }
        };

        countrySelect.on('change', (e) => {
            updateVatRequirement(e.target.value);
        });

        // Initial state
        if (countrySelect.val()) {
            updateVatRequirement(countrySelect.val());
        }
    }

    handleSubmit() {
        // Handle button click
        this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();

            // Show loading state
            this.submitButton.setAttribute('data-kt-indicator', 'on');
            this.submitButton.disabled = true;

            // Validate form
            if (this.validator) {
                this.validator.validate().then((status) => {
                    if (status === 'Valid') {
                        // Save form data locally
                        this.saveFormData();

                        // Save to server
                        this.saveStepProgress().then((response) => {
                            if (response.url) {
                                console.log('Redirecting to payment:', response.url);
                                window.location.href = response.url;
                            } else {
                                // Fallback: if no URL returned, go to loader
                                register.goNext('loader');
                            }
                        }).catch((error) => {
                            console.error('Error saving step 9 progress:', error);
                            // Hide loading state on error
                            this.submitButton.removeAttribute('data-kt-indicator');
                            this.submitButton.disabled = false;
                        });
                    } else {
                        // Hide loading state
                        this.submitButton.removeAttribute('data-kt-indicator');
                        this.submitButton.disabled = false;
                    }
                });
            }
        });
    }

    saveFormData() {
        // Get form data
        const formData = new FormData(this.form);

        // Save to global register data
        if (!window.register.companyData) {
            window.register.companyData = {};
        }

        const fields = ['ia_street', 'ia_nr', 'ia_nr_add', 'ia_postal', 'ia_city', 'ia_country', 'ia_vat_number'];

        fields.forEach(field => {
            window.register.companyData[field] = formData.get(field);
        });

        console.log('Location data saved:', window.register.companyData);
    }

    populateForm() {
        // Pre-fill form if data exists
        if (window.register.companyData) {
            const fields = ['ia_street', 'ia_nr', 'ia_nr_add', 'ia_postal', 'ia_city', 'ia_country', 'ia_vat_number'];

            fields.forEach(field => {
                const element = this.form.querySelector(`[name="${field}"]`);
                if (element && window.register.companyData[field]) {
                    element.value = window.register.companyData[field];

                    // Trigger change for select2 if it's the country field
                    if (field === 'ia_country' && $(element).data('control') === 'select2') {
                        $(element).trigger('change');
                    }
                }
            });
        }
    }

    async saveStepProgress() {
        const formData = new FormData(this.form);
        const fields = ['ia_street', 'ia_nr', 'ia_nr_add', 'ia_postal', 'ia_city', 'ia_country', 'ia_vat_number'];
        const stepData = {};

        fields.forEach(field => {
            stepData[field] = formData.get(field);
        });

        try {
            const response = await API.post('/register/saveStep', {
                step: 10,
                data: stepData
            });

            return response;
        } catch (error) {
            console.error('Error saving step 10 progress:', error);
            throw error;
        }
    }

    isComplete() {
        if (!this.form) return false;

        const street = this.form.querySelector('[name="ia_street"]').value.trim();
        const nr = this.form.querySelector('[name="ia_nr"]').value.trim();
        const postal = this.form.querySelector('[name="ia_postal"]').value.trim();
        const city = this.form.querySelector('[name="ia_city"]').value.trim();
        const country = this.form.querySelector('[name="ia_country"]').value;
        const vat = this.form.querySelector('[name="ia_vat_number"]').value.trim();

        const basicComplete = street.length > 0 && nr.length > 0 && postal.length > 0 && city.length > 0;
        const vatComplete = country === 'nl' || vat.length > 0;

        return basicComplete && vatComplete;
    }
}

export default Step9;
